export const ALIGNMENTS = ["left", "center", "right", "justify"];

export const LANGUAGES = [
  {
    code: "sk",
    name: "Slovensky",
  },
  {
    code: "cz",
    name: "Česky",
  },
  {
    code: "en",
    name: "English",
  },
  {
    code: "de",
    name: "Deutsch",
  },
];

export const DSOK_LANGUAGES = [
  {
    code: "sk",
    name: "Slovensky",
  },
  {
    code: "en",
    name: "English",
  },
  {
    code: "cs",
    name: "Česky",
  },
  {
    code: "de",
    name: "Deutsch",
  },
  {
    code: "uk",
    name: "Українська",
  },
  {
    code: "pl",
    name: "Polski",
  },
  {
    code: "hu",
    name: "Magyar",
  },
];
export const EASY_SERVICES = [
  {
    code: "easy-buy",
    name: "Easy Buy",
  },
  {
    code: "easy-pay",
    name: "Easy Pay",
  },
];

export const RECOMMENDED_PRODUCTS_VIEW_TYPES = [
  {
    code: "slider",
    name: "Slider",
  },
  {
    code: "grid",
    name: "Grid",
  },
];
export const DSOK_SLIDER_EFFECTS = [
  {
    code: "slide",
    name: "Slide",
  },
  {
    code: "fade",
    name: "Fade",
  },
];
export const DSOK_LAST_CATEGORY_TYPES = [
  {
    code: "categories",
    name: "categories",
  },
  {
    code: "categories-with-sidebar",
    name: "categories-with-sidebar",
  },
];

export const CATEGORY_PRODUCTS_DISPLAY_TYPES = [
  {
    code: "all",
    name: "All",
  },
  {
    code: "image",
    name: "Image",
  },
  {
    code: "label",
    name: "Label",
  },
];
export const CATEGORY_PRODUCTS_ACTIONS = [
  {
    code: "product-detail",
    name: "product-detail",
  },
  {
    code: "products-grid",
    name: "products-grid",
  },
];
export const SMARTKIOSK_DYNAMIC_COMPONENTS_VIEWS = [
  {
    code: "cart",
    name: "cart",
  },
  {
    code: "product-detail",
    name: "product-detail",
  },
  {
    code: "products-grid",
    name: "products-grid",
  },
];

export const SMARTKIOSK_DYNAMIC_COMPONENTS_POSITIONS_CART = [
  {
    code: "overlay",
    name: "overlay",
  },
];
export const SMARTKIOSK_DYNAMIC_COMPONENTS_POSITIONS_PRODUCTS_GRID = [
  {
    code: "before-search",
    name: "before-search",
  },
  {
    code: "before-grid",
    name: "before-grid",
  },
];
export const SMARTKIOSK_DYNAMIC_COMPONENTS_POSITIONS_PRODUCT_DETAIL = [
  {
    code: "before-main-content",
    name: "before-main-content",
  },
  {
    code: "after-main-content",
    name: "after-main-content",
  },
];

export const CURRENCY_CODE_POSITIONS = [
  {
    code: "left",
    name: "Left",
  },
  {
    code: "right",
    name: "Right",
  },
];

export const DSOK_AUTH_METHODS = [
  {
    code: "none",
    name: "None",
  },
  {
    code: "qrCode",
    name: "QR Code",
  },
  {
    code: "vexionQrCode",
    name: "Vexion QR Code",
  },
  {
    code: "vexionEmail",
    name: "Vexion Email",
  },
  {
    code: "vexionPhone",
    name: "Vexion Phone",
  },
  {
    code: "snopNationalRegNo",
    name: "STAPRO National Registration Number",
  },
  {
    code: "iclub-email",
    name: "iClub Email",
  },
  {
    code: "iclub-card-code",
    name: "iClub Card Code",
  },
  {
    code: "iclub-qrcode",
    name: "iClub QR Code",
  },
  {
    code: "iclub-sign-up",
    name: "iClub Sign Up",
  },
];

/** Default loyalty system is Datavision. */
export const DSOK_LOYALTY_SYSTEMS = [
  {
    code: "none",
    name: "None",
  },
  {
    code: "datavision",
    name: "Datavision",
  },
  {
    code: "vexion",
    name: "Vexion",
  },
];

/** Returns translationCode prefix for loyalty provider (e.g. "vexion" => "vexionLevel1"). */
export function getLoyaltyTranslationCodePrefix(loyaltyType) {
  if (!loyaltyType || loyaltyType === "none") return "";
  return String(loyaltyType).toLowerCase();
}

export const DSOK_PAYMENT_METHODS = [
  {
    code: "none",
    name: "None",
  },
  {
    code: "card",
    name: "Card",
  },
  {
    code: "cash",
    name: "Cash",
  },
  {
    code: "qrCode",
    name: "QR Code",
  },
  {
    code: "invoice",
    name: "Invoice",
  },
  {
    code: "albaconCashMachine",
    name: "Cash machine (ALBACON)",
  },
];

export const DSOK_SECONDARY_AUTH_METHODS = [
  {
    code: "none",
    name: "None",
  },
  {
    code: "pinCode",
    name: "PIN Code",
  },
];
export const DSOK_DYNAMIC_COMPONENTS_TYPES = [
  {
    code: "PaymentOverlay",
    name: "PaymentOverlay",
  },
  {
    code: "PaintCoverageCalculator",
    name: "PaintCoverageCalculator",
  },
  {
    code: "CarPaintInfoForm",
    name: "CarPaintInfoForm",
  },
];
export const VAT_COUNTRY_CODES = [
  {
    code: "sk",
    name: "SK",
  },
  {
    code: "cz",
    name: "CZ",
  },
];
export const CURRENCY_CODES = [
  {
    code: "EUR",
    name: "EUR",
  },
  {
    code: "Kč",
    name: "Kč",
  },
];
export const FRONTEND_TYPE = [
  {
    code: "gastrokiosk",
    name: "Gastrokiosk",
  },
  {
    code: "easyPay",
    name: "EasyPay",
  },
  {
    code: "smartKiosk",
    name: "SmartKiosk",
  },
  {
    code: "easyFood",
    name: "EasyFood",
  },
];

export const LINE_OF_BUSINESS = [
  {
    code: "other",
    name: "Other",
  },
  {
    code: "gastro",
    name: "Gastro",
  },
  {
    code: "retail",
    name: "Retail",
  },
  {
    code: "concreteStation",
    name: "Concrete Station",
  },
  {
    code: "sportsCenter",
    name: "Sports Center",
  },
];
export const BAR_CODE_TYPES = [
  {
    code: "",
    name: "None",
  },
  {
    code: "EAN13",
    name: "EAN13",
  },
  {
    code: "EAN8",
    name: "EAN8",
  },
];

export const DSOK_POS_SUPPLIERS = [
  {
    code: "none",
    name: "None",
  },
  {
    code: "besteron",
    name: "Besteron",
  },
  {
    code: "fiskalPro",
    name: "FiskalPro",
  },
  {
    code: "iKelpPosManager",
    name: "iKelpPosManager",
  },
  {
    code: "teya",
    name: "TEYA",
  },
  {
    code: "sonet",
    name: "SONET",
  },
  {
    code: "globalPayments",
    name: "GlobalPayments",
  },
  {
    code: "dotypay",
    name: "DotyPay",
  },
];

// Backward compatibility alias used by some components
export const DSOK_SUPPLIERS = DSOK_POS_SUPPLIERS;

/**
 * DSOK Daily Menu types (predefined). Used by the daily-menu edit form (menuType select)
 * and by the daily-menu screen settings tab (per-type from/to times).
 */
export const DAILY_MENU_TYPES = [
  { code: "breakfast", name: "Raňajky" },
  { code: "lunch", name: "Obed" },
  { code: "dinner", name: "Večera" },
  { code: "night", name: "Noc" },
];

/** Preddefinované vizuálne šablóny (templaty) obrazovky denného menu. */
export const DAILY_MENU_TEMPLATES = [
  {
    id: "template_1",
    name: "Template 1",
    image: "/images/daily-menu-templates/template_1.jpg",
  },
  {
    id: "template_2",
    name: "Template 2",
    image: "/images/daily-menu-templates/template_2.jpg",
  },
];

/** External device type codes for DSOK (printers, workspace devices). Labels from i18n: dsokCustomerDetail.printers.types.<code> */
export const DSOK_EXTERNAL_DEVICE_TYPES = [
  { code: "kitchenPrinter" },
  { code: "ticketPrinter" },
];

/** Device connection type for workspace devices. Labels from i18n: dsokCustomerDetail.workspaces.devices.connectionTypes.<code> */
export const DSOK_DEVICE_CONNECTION_TYPES = [
  { code: "IP" },
  { code: "USB" },
  { code: "RS232" },
];

export const DSOK_ORDER_MANAGEMENT_TYPES = [
  {
    company: "None",
    code: "none",
  },
  {
    company: "IKELP",
    code: "ikelp",
    fetchProductsUrl: "xxx",
    orderCreateUrl: "true",
  },
  {
    company: "n8n workflow",
    code: "n8n",
    fetchProductsUrl: "",
    orderCreateUrl: "",
  },
  {
    company: "DSOK Integration Server PROD",
    code: "dsokIntegration",
    fetchProductsUrl: "",
    orderCreateUrl: "",
  },
  {
    company: "DSOK Integration Server STAGING",
    code: "dsokIntegrationStaging",
    fetchProductsUrl: "",
    orderCreateUrl: "",
  },
  {
    company: "Dotykačka",
    code: "dotykacka",
    orderCreateUrl: "",
    refreshToken: "true",
    cloudId: "true",
  },
  {
    company: "Storyous",
    code: "storyous",
    fetchProductsUrl: "",
    orderCreateUrl: "",
  },
  {
    company: "Oberon",
    code: "oberon",
    fetchProductsUrl: "",
    orderCreateUrl: "",
  },
  {
    company: "maandro",
    code: "maandro",
    fetchProductsUrl: "",
    orderCreateUrl: "",
  },
];

export const WRISTBAND_TEMPALTE_TYPES = [
  {
    company: "standard",
    code: 1,
  },
  {
    company: "inverse",
    code: 2,
  },
];

// Device Health Check options
export const DEVICE_HEALTH_CHECK_OPTIONS = [
  { value: "POS", label: "POS" },
  { value: "PRINTER_EKASA", label: "Printer + eKasa" },
  { value: "PRINTER", label: "Printer" },
];
export const ZERO_PRICE_OPTIONS = ["0", "free", "included"];
export const TIME_BASED_PRICE_DISCOUNT_TYPES = [
  "amount",
  "percent",
  "fixedPrice",
];
export const TIME_BASED_PRICE_LABELS = ["none", "sale", "happyHour"];
export const CROSS_SELL_PLACEMENTS = [
  "after_adding_product_to_cart",
  "checkout_page",
  "product_detail_page",
];

export const PRODUCT_LABELS = [
  {
    code: "none",
    name: "None",
  },
  {
    code: "sale",
    name: "Sale",
  },
  {
    code: "happyHour",
    name: "Happy Hour",
  },
  {
    code: "new",
    name: "New",
  },
  {
    code: "favourite",
    name: "Favourite",
  },
];

export const DSOK_PRODUCTS_MANAGEMENT_TYPES = [
  {
    company: "None",
    code: "none",
    showUrl: false,
    showImportProductsButton: true,
  },
  {
    company: "IKELP",
    code: "ikelp",
    showUrl: true,
  },
  {
    company: "n8n workflow",
    code: "n8n",
    showUrl: true,
    showImportProductsButton: true,
  },
  {
    company: "DSOK Integration Server PROD",
    code: "dsokIntegration",
    showUrl: false,
    showImportProductsButton: true,
  },
  {
    company: "DSOK Integration Server STAGING",
    code: "dsokIntegrationStaging",
    showUrl: false,
    showImportProductsButton: true,
  },
  {
    company: "Oberon",
    code: "oberon",
    showUrl: true,
    showHelpText: false,
    showImportProductsButton: false,
    showCredentials: true,
    showAdditionalVariables: true,
    additionalVariables: {
      categoryName: {
        type: "text",
        label: "Názov kategórie",
        description:
          "Názov hlavnej kategórie v Oberone, ktorej položky sa budú importovať",
        value: "",
      },
      categoryId: {
        type: "text",
        label: "ID kategórie",
        description:
          "ID hlavnej kategórie v Oberone, ktorej položky sa budú importovať, ID sa dá nájsť cv XML export v Oberone v zozname kategórií",
        value: "",
      },
      cardPaymentMethodName: {
        type: "text",
        label: "Názov identifikátora platby kartou",
        description:
          "Názov metódy platby kartou v Oberone. Identifikátork, ktorý sa posiela pri objednávke. Zoznam je dostupný na napr: https://192.168.100.192:21002/v1/cashregister/payment-types/list",
        value: "",
      },
      stockGroup: {
        type: "switch",
        label: "Prenášať prídavky",
        description:
          'Povoliť prenos prídavkov z Oberon. Ak je prepínač zapnutý, prídavky sa z položky "Skladová skupina" v nastavení položky v sklade.',
        value: "",
      },
      syncDescription: {
        type: "switch",
        label: "Prenášať popis produktu",
        description:
          'Ak je zapnuté, pri importe sa z Oberonu prenáša aj popis produktu (pole "Doplnkový text"). Ak je vypnuté, popis sa neprenáša ani neprepisuje — môžete si ho spravovať ručne.',
        value: "",
        defaultOn: true,
      },
    },
    authEnabled: {
      type: "switch",
      label: "Povoliť autentifikáciu",
    },
    credentials: {
      username: {
        type: "text",
        label: "Username",
        value: "",
      },
      password: {
        type: "text",
        label: "Password",
        value: "",
      },
    },
  },
  {
    company: "WooCommerce (WordPress)",
    code: "woocommerce",
    showUrl: false,
    showHelpText: true,
    helpText:
      "WooCommerce REST API v3. Prepojí konkrétnu WordPress/WooCommerce stránku s týmto zákazníkom. Zadajte URL WordPress stránky (napr. https://shop.example.com, bez /wp-json) a Consumer Key/Secret s právami len na Čítanie (WooCommerce → Nastavenia → Rozšírené → REST API → Pridať kľúč). Importujú sa produkty typu simple v stave publish + ploché kategórie.",
    // Credentials + import/test are rendered by a dedicated WooCommerce block (masked secret),
    // so the generic credentials block and the generic import button are disabled here.
    showCredentials: false,
    showImportProductsButton: false,
    showAdditionalVariables: true,
    additionalVariables: {
      storeUrl: {
        type: "text",
        label: "URL WordPress stránky",
        description:
          "Koreňová URL WooCommerce stránky, napr. https://shop.example.com (bez /wp-json/wc/v3).",
        value: "",
      },
      taxClassMap: {
        type: "text",
        label: "Mapovanie DPH (tax_class → %)",
        description:
          'JSON mapovanie WooCommerce tax_class na sadzbu DPH v %, napr. {"":23,"reduced-rate":10}. Prázdny kľúč "" = štandardná sadzba. Produkty s tax_status=none dostanú 0 %.',
        value: "",
      },
      categoryFilter: {
        type: "text",
        label: "Filter kategórie (ID) — voliteľné",
        description:
          "Ak je vyplnené, importujú sa len produkty z danej WooCommerce kategórie (číselné ID). Prázdne = všetky.",
        value: "",
      },
    },
    // Consumed by the WooCommerce block and by the backend (credentials.username/password.value).
    credentials: {
      username: {
        type: "text",
        label: "Consumer Key",
        value: "",
      },
      password: {
        type: "password",
        label: "Consumer Secret",
        value: "",
      },
    },
  },
];

export const DAYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

// DSOK-475: "QR" is the menu code/type for QR table ordering. A menu with code "QR"
// tags its categories with menuType "QR", which the public QR API reads
// (helper/qr/qrMenu.js → filterQrCategories: category.menuType === "QR").
export const DSOK_MENU_TYPES = ["TAKEAWAY", "DINE_IN", "QR"];

export const DSOK_REPORTS_TYPES = ["daily", "monthly"];

export const DSOK_TRANSACTION_TYPES = [
  { name: "transactionLive", code: "live" },
  { name: "transactionTest", code: "test" },
];

export const PORTOS_CUSTOMER_TYPES = [{ name: "ICO", code: "ICO" }];

export const DSOK_EKASA_TYPES = [
  { name: "none", code: "none" },
  { name: "portosSk", code: "portos_sk" },
  { name: "fiskalProSk", code: "fiskalPro_sk" },
  { name: "iKelpPosManagerSk", code: "iKelpPosManager_sk" },
  { name: "iKelpPosManagerPosPrinter", code: "iKelpPosManagerPosPrinter" },
  { name: "dsokPrinter", code: "dsokPrinter" },
  { name: "eetCz", code: "eet_cz" },
];

// Česká EET – režim evidencie a prostredie
export const EET_REZIMY = [
  { name: "eetRezimProdukcni", code: "produkcni" },
  { name: "eetRezimOvereni", code: "overeni" },
];

export const EET_PROSTREDIA = [
  { name: "eetProstrediePlayground", code: "playground" },
  { name: "eetProstredieProdukcni", code: "produkcni" },
];

export const BE_DOMAINS = [
  "https://be.gastrokiosk.online",
  "https://staging.gastrokiosk.online",
  "https://be-gc.gastrokiosk.online",
];

export const DSOK_FE_DOMAIN = "gastrokiosk.eu";

export const MONTHS = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

export const DSOK_ORDER_STATUSSES = [
  "sent",
  "created",
  "payment failed",
  "complete",
];

export const DSOK_DEVICE_SERVER_PORT_START = 12000;

export const VAT_RATES = [0, 10, 20];
/** Slovensko: 23 %, 19 %, 5 %, 0 % */
export const VAT_RATES_SK = [
  { key: "vat23", value: 23 },
  { key: "vat19", value: 19 },
  { key: "vat5", value: 5 },
  { key: "vat0", value: 0 },
];
/** Česko: 21 %, 12 %, 0 % */
export const VAT_RATES_CZ = [
  { key: "vat21", value: 21 },
  { key: "vat12", value: 12 },
  { key: "vat0", value: 0 },
];

export const ALLERGENS_LIST = () => {
  return {
    Gluten: {
      number: 1,
      title: {
        sk: "Obilniny obsahujúce lepok",
        en: "Cereals containing gluten",
        cs: "Obiloviny obsahující lepek",
        // de: 'Glutenhaltiges Getreide',
        // it: 'Cereali contenenti glutine'
      },
    },
    Crustaceans: {
      number: 2,
      title: {
        sk: "Kôrovce a výrobky z nich",
        en: "Crustaceans and products thereof",
        cs: "Korýši a výrobky z nich",
        // de: 'Krustentiere und daraus hergestellte Erzeugnisse',
        // it: 'Crostacei e prodotti derivati'
      },
    },
    Eggs: {
      number: 3,
      title: {
        sk: "Vajcia a výrobky z nich",
        en: "Eggs and products thereof",
        cs: "Vejce a výrobky z nich",
        // de: 'Eier und daraus hergestellte Erzeugnisse',
        // it: 'Uova e prodotti derivati'
      },
    },
    Fish: {
      number: 4,
      title: {
        sk: "Ryby a výrobky z nich",
        en: "Fish and products thereof",
        cs: "Ryby a výrobky z nich",
        // de: 'Fisch und Fischereierzeugnisse',
        // it: 'Pesce e prodotti a base di pesce'
      },
    },
    Peanuts: {
      number: 5,
      title: {
        sk: "Arašidy a výrobky z nich",
        en: "Peanuts and products thereof",
        cs: "Arašídy a výrobky z nich",
        // de: 'Erdnüsse und daraus hergestellte Erzeugnisse',
        // it: 'Arachidi e prodotti derivati'
      },
    },
    Soya: {
      number: 6,
      title: {
        sk: "Sójové zrná a výrobky z nich",
        en: "Soya beans and products thereof",
        cs: "Sójové boby a výrobky z nich",
        // de: 'Sojabohnen und Sojaerzeugnisse',
        // it: 'Semi di soia e prodotti derivati'
      },
    },
    Milk: {
      number: 7,
      title: {
        sk: "Mlieko a výrobky z neho (vrát. laktózy)",
        en: "Milk and milk products (including lactose)",
        cs: "Mléko a mléčné výrobky (včetně laktózy)",
        // de: 'Milch und Milcherzeugnisse (einschließlich Laktose)',
        // it: 'Latte e prodotti lattiero-caseari (compreso il lattosio)'
      },
    },
    Nuts: {
      number: 8,
      title: {
        sk: "Orechy, t. j. mandle",
        en: "Nuts, i.e. almonds",
        cs: "Ořechy, tj. mandle",
        // de: 'Nüsse, z.B. Mandeln',
        // it: 'Frutta a guscio, ad esempio mandorle'
      },
    },
    Celery: {
      number: 9,
      title: {
        sk: "Zeler a výrobky z neho",
        en: "Celery and products thereof",
        cs: "Celer a výrobky z něj",
        // de: 'Sellerie und daraus hergestellte Erzeugnisse',
        // it: 'Sedano e prodotti derivati'
      },
    },
    Mustard: {
      number: 10,
      title: {
        sk: "Horčica a výrobky z nej",
        en: "Mustard and products thereof",
        cs: "Hořčice a výrobky z ní",
        // de: 'Senf und Senferzeugnisse',
        // it: 'Senape e prodotti derivati'
      },
    },
    Sesame: {
      number: 11,
      title: {
        sk: "Sezamové semená a výrobky z nich",
        en: "Sesame seeds and products thereof",
        cs: "Sezamová semínka a výrobky z nich",
        // de: 'Sesamsamen und daraus hergestellte Erzeugnisse',
        // it: 'Semi di sesamo e prodotti derivati'
      },
    },
    Sulphites: {
      number: 12,
      title: {
        sk: "Oxid siričitý a siričitany",
        en: "Sulphur dioxide and sulphites",
        cs: "Oxid siřičitý a siřičitany",
        // de: 'Schwefeldioxid und Sulfite',
        // it: 'Anidride solforosa e solfiti'
      },
    },
    Lupine: {
      number: 13,
      title: {
        sk: "Vlčí bôb a výrobky z neho",
        en: "Lupin and products thereof",
        cs: "Lupina a výrobky z ní",
        // de: 'Lupinen und Lupinenerzeugnisse',
        // it: 'Lupino e prodotti derivati'
      },
    },
    Molluscs: {
      number: 14,
      title: {
        sk: "Mäkkýše a výrobky z nich",
        en: "Molluscs and products thereof",
        cs: "Měkkýši a výrobky z nich",
        // de: 'Weichtiere und daraus hergestellte Erzeugnisse',
        // it: 'Molluschi e prodotti derivati'
      },
    },
  };
};
